import '../zod-extensions' // Ensure extensions are loaded before schema evaluation
import { z } from 'zod'
import { fileMaxSizeSchema } from '../zod-shared-schemas'

export const SWORD_DESK_MAX_FILE_SIZE_MB = 50

export const swordDeskSchema = z.object({
  ticketTitle: z.string().max(255),
  ticketDescription: z.string(),
  fileForUpload: fileMaxSizeSchema(SWORD_DESK_MAX_FILE_SIZE_MB),
})
